<template>
  <!-- ホルター心電図解析結果入力詳細 -->
  <div id="HolterAnalysisResultDetail">
    <div id="container">
      <div class="labelTitle lable">ホルター心電図解析 解析結果入力</div>
      <div class="button-area">
        <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr><th>受付番号</th><td>{{data.receiptNumber}}<span v-if="data.depositMachineFlag" class="depo"/></td></tr>
            <tr><th>返却希望日</th><td>{{data.returnDate}}</td></tr>
            <tr>
              <th>解析担当者</th>
              <td>
                {{data.analysisStaffName}}
                <b-button style="margin-left:10px; width:150px; height:27px;" @click="analyistSelectModalActive=true">担当者変更</b-button>
              </td>
            </tr>
            <tr><th>解析期限</th><td>{{data.analysisDeadline}}</td></tr>
            <tr>
              <th style="vertical-align:top;">受付備考</th>
              <td><textarea v-model="data.note" maxlength="256" style="resize:vertical;max-width:100%;height:50px;"></textarea></td>
            </tr>
            <tr v-if="data.rejectHistory && data.rejectHistory.length > 0">
              <th>却下理由</th>
              <td colspan="2">
                <table class="reject-reason-table">
                  <tr>
                    <th class="reject-date">日時</th>
                    <th>理由</th>
                  </tr>
                  <tr v-for="reject in data.rejectHistory" :key="reject.value">
                    <td class="reject-date">{{ reject.completionDate }}</td>
                    <td>{{ reject.reason }}</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr v-if="data.holterRequestId==null">
              <th>解析方法</th>
              <td>{{data.analysisMethod | choiceFilter(analysisMethodList)}}</td>
            </tr>
            <tr v-if="data.holterRequestId!=null">
              <th>解析方法</th>
              <td>ホルター心電図</td>
            </tr>
            <tr><th>検査日<span class="require"/></th>
            <td v-if = "isHolterService()"><input type="date" style="width:200px;height: 27px;" class="edit" name="検査日" validate="required" v-model="data.inspectionDate" :max="yyyy_hyp_MM_hyp_dd(new Date())" /></td>
              <td v-if = "!isHolterService()"><input type="date" style="width:200px;height: 27px;" class="edit" name="検査日" validate="required" v-model="data.inspectionDate" :max="yyyy_hyp_MM_hyp_dd(new Date())" /></td></tr>
            <tr><th>CVHRI<span class="require"/></th><td><input type="text" class="edit" :disabled="isCvhriNotCalcCheck" v-model="data.cvhri" name="CVHRI" :validate="`${isCvhriNotCalcCheck ? '':'required||double'}`"/></td></tr>
            <tr><th></th><td><b-checkbox style="width: 26px" v-model="isCvhriNotCalcCheck"></b-checkbox>CVHRI算出不可</td></tr>
            <tr>
              <th>AFの有無<span class="require"/></th>
              <td>
                <select class="edit" v-model="data.af" name="AF" validate="required">
                <option></option>
                <option value="1">有り</option>
                <option value="2">無し</option>
                </select>
              </td>
            </tr>
            <tr><th>メモ</th><td><textarea maxlength="256" style="resize:vertical;max-width:100%;" v-model="data.memo"></textarea></td></tr>
            <tr>
              <th style="vertical-align:top;">アップロードファイル名</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><span>{{uploadFileName}}<b-button class="clipbordcopy is-primary" @click="clipboardCopy()">コピーする</b-button></span></td>
            </tr>
            <tr>
              <th>レポートアップロード<span class="require" /></th>
              <td>
                <div class="upload_area" @dragenter="dragEnter">
                  <span class="upload_span">ここに添付する解析データをドラッグアンドドロップするか、「ファイルを追加」を押します。</span>
                </div>
              </td>
              <b-modal :active.sync="isUpdateModal" has-modal-card  >
                <div class="modal-card uploadModal" 
                  @dragleave="dragLeave"
                  @drop.prevent="fileDorop"
                >
                    ここに解析データファイルをドロップします。
                </div>
              </b-modal>
            </tr>
            <tr>
              <th></th>
              <td>                        
                <b-upload v-model="upButtonFile"  class="file-label" v-on:input="addUploadfile" multiple>
                  <span class="file-cta">
                    <span class="file-label">ファイルを追加</span>
                  </span>
                </b-upload>
              </td>
            </tr>
            <tr>
              <th></th>
              <td>
                <table>
                  <template v-for="(preUpfile,index) of preUpFiles">
                    <tr :key="index + 'pre'">
                      <td style="width: 20px"><b-icon icon="paperclip" /></td><td style="width: 430px">{{preUpfile.path}}</td><td><a @click="deleteUpfile(preUpFiles, index)"><b-icon icon="delete-forever-outline " /></a>
                      </td>
                    </tr>
                  </template>
                  <template v-for="(upfile,index) of upFiles">
                    <tr :key="index">
                      <td style="width: 20px"><b-icon icon="paperclip" /></td><td style="width: 430px">{{upfile.path}}</td><td><a @click="deleteUpfile(upFiles, index)"><b-icon icon="delete-forever-outline " /></a>
                      </td>
                    </tr>
                  </template>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="is-primary" @click="approvalRequest">承認依頼</b-button>
        </div>
      </div>
      <div style="height:5px;" />
      <div class="labelTitle lable">申込内容</div>
      <div id="item-contens">
        <holterAnalysisRequestDetail v-if="showDetail" v-bind:data="detailData" :canDownload="true" :editFlag="true" :hstRequestId="data.holterRequestId" :belongsNote="data.belongsNote" :isInternalPsg="true" :isClipboardCopy="true"/>
      </div>
      <div class="button-area">
        <b-button class="receptionistButton is-primary" @click="save">更新</b-button>
        <b-button class="is-primary" v-if="!isHolterService()" icon-left="mail" style="width:200px;" @click="replaceReasonInputModalActive=true">データ差し替え依頼</b-button>
        <b-button class="is-primary" v-if="!isHolterService()" @click="cancelReasonInputModalActive=true">解析をキャンセル</b-button>
        <b-button class="is-primary" v-if="isHolterService()" @click="reInspectReasonInputModalActive=true">再検査調整</b-button>
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
    </div>
    <b-modal :active.sync="replaceReasonInputModalActive" has-modal-card>
      <reasonInputModal  v-on:setReason="dataReplace" v-bind:title="'データ差し替え(再アップロード依頼理由入力)'"></reasonInputModal>
    </b-modal>
    <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
      <reasonInputModal  v-on:setReason="analysisCancel" v-bind:title="'解析キャンセル(キャンセル理由入力)'"></reasonInputModal>
    </b-modal>
    <b-modal :active.sync="reInspectReasonInputModalActive" has-modal-card>
      <reasonInputModal  v-on:setReason="reInspectAdjust" v-bind:title="'再検査調整(再検査理由入力)'"></reasonInputModal>
    </b-modal>
    <b-modal :active.sync="analyistSelectModalActive" has-modal-card>
      <analyistSelectModal :selectRole="[role.role_psc, role.role_analysis]" title="解析担当者選択" labelForOrg="解析担当者" @select="changeAnalyst"></analyistSelectModal>
    </b-modal>
  </div>
</template>

<script>
import {atLaunchHidden} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import holterAnalysisRequestDetail from "@/components/mock/common/HolterAnalysisRequestDetail";
import {UploadType} from "@/components/mock/base/const.js";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import AnalyistSelectModal from "@/components/mock/philips/common/AnalyistSelectModal";
import {role} from "@/components/mock/base/const.js";
export default {
  name: "HolterAnalysisResultDetail",
  methods: {
    getReceptionData: function() {
      var excuteApi = this.getHolterAnalysisResultDetailPOST;
      var successCallBack = this.getHolterAnalysisResultDetailPOSTSuccess;
      var errorCallBack = this.getHolterAnalysisResultDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterAnalysisResultDetailPOST: function(client) {
      return client.apis.internalHolterAnalysis.getHAnalysisResultDetailPOST({
        body:{receiptNumber: this.receiptNumber}
      });
    },
    getHolterAnalysisResultDetailPOSTSuccess: function(result) {
      this.data = result.obj
      this.data.af = this.data.afKind
      this.uploadFileName = this.data.hospitalName + "_" + this.data.patientName + "様"
      this.uploadFileName = this.uploadFileName.replace(/[\\/:*?"<>|]/g,'_')
      this.replaceFiles = this.getCopy(this.data.analysisResultFileList);
      if(this.data.cvhri == -1){
        // CVHRI算出不可案件の場合(cvhri=-1)、初期値としてチェックボックス(CVHRI算出不可)をtrue(チェック有)とする
        this.isCvhriNotCalcCheck = true
        this.data.cvhri = null
      }
    },
    getHolterAnalysisResultDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    getDetail: function() {
      var excuteApi = this.getAnalysisDetailPOST;
      var successCallBack = this.getAnalysisDetailPOSTSuccess;
      var errorCallBack = this.getAnalysisDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAnalysisDetailPOST: function(client) {
      return client.apis.internalHolterAnalysis.getHAnalysisRequestDetailPOST({
        body:{receiptNumber: this.receiptNumber}
      });
      //return client.apis.externalAnalysis.getAnalysisDetailPOST({
      //  body:{receiptNumber: this.receiptNumber}
      //});
    },
    getAnalysisDetailPOSTSuccess: function(result) {
      var res = result.obj
      this.detailData = res.applicationDetails
      this.showDetail = true;
      this.version = res.version;
    },
    getAnalysisDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    changeAnalyst: function(analyistInfo) {
      this.analystId = analyistInfo.id;
      this.$dialog.confirm({
        title: "変更確認",
        message: "解析担当者を変更しますか？",
        confirmText:"OK",
        cancelText: "キャンセル",
        onConfirm: async() => {
          // 変更する
          var excuteApi = this.setHolterAnalysisReceptionAnalystChangePOST;
          var successCallBack = this.setHolterAnalysisReceptionAnalystChangePOSTSuccess;
          var errorCallBack = this.setHolterAnalysisReceptionAnalystChangePOSTError;
          // Web Api Call
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        }
      });
    },
    setHolterAnalysisReceptionAnalystChangePOST: function(client){
      return client.apis.internalHolterAnalysis.setHAnalysisReceptionAnalystChangePOST({
        body:{ 
          receptionRecordID: this.data.receptionRecordID,
          analystId: this.analystId ,
          receptionRecordVersion: this.data.receptionRecordVersion
        }
      });
    },
    setHolterAnalysisReceptionAnalystChangePOSTSuccess: function(result){
      this.getReceptionData()
      this.getDetail()
      this.showMessage("担当者を更新しました。");
    },
    setHolterAnalysisReceptionAnalystChangePOSTError: function(result){
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    back: function () {
      this.$router.push({
        name: "HolterAnalysisResult",
        params: { searchConditions: this.searchParams },
      });
    },
    save: async function () {
      // 承認依頼
      var errMsg = ""
      if (this.upFiles.length!=0 || this.preUpFiles.length != 0) {
        let preNameList = this.preUpFiles.map(item => item['path']);
        let nameList = this.upFiles.map(item => item['path']);
        nameList = nameList.concat(preNameList);
        for(let i = 0; i < nameList.length; i++){
          if(nameList[i].startsWith("/")){
            let zipName = nameList[i].replace("/", "");
            nameList[i] = zipName + ".zip"
          }
        }
        const setElements = new Set(nameList);
        if (setElements.size !== nameList.length) {
          errMsg = errMsg + "添付データの重複しているファイルが存在します。\n"
        }
        let targetFile = this.upFiles;
        let okSize = await this.checkUploadFileSize(targetFile);
        if(!okSize){
          errMsg = errMsg + "2GBを超えるファイルはアップロードできません。\n"
        }
      }
      if(errMsg) {
        this.showErrorMessage(errMsg)
        return
      }

      // ファイル名チェック
      var fileNameCheck = true
      for(let uploadItemIfno of this.upFiles){
        var name = uploadItemIfno.file.name
        if(name.indexOf(".") != -1){
          if(name.indexOf(this.uploadFileName) == -1){
            // ファイル名に含まれない
            fileNameCheck = false
            break;
          }
        }
      }
      if(!fileNameCheck){
        this.showErrorMessage("添付したファイルの患者名と医療機関名が正しくない可能性があります。")
        return
      }
      //まずはファイルのアップロードから
      this.multipleUpload(this.upFiles ,this.data.receiptNumber, this.UploadType.holter_report)
      .then(reslut =>{
        this.currentUploadFile = reslut;
        var excuteApi = this.setHolterAnalysisTempSavePOST;
        var successCallBack = this.setHolterAnalysisTempSavePOSTSuccess;
        var errorCallBack = this.setHolterAnalysisTempSavePOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      })
      .catch(error =>{
        this.showErrorMessage("ファイルアップロードに失敗した為、申込みをキャンセルしました。<br>再度実行してください。");
      });
    },
    setHolterAnalysisTempSavePOST: function(client) {
      var obj = ({
        receiptNumber: this.data.receiptNumber, // 申込みID
        version: this.version, // バージョン
        viewType:"解析結果入力",
        applicationNote:this.detailData.biko, // 依頼内容備考(申送り事項)
        //analysisStaffCode 解析担当者ID
        //analysisDeadline 解析期限
        receptionNote: this.data.note, // 受付備考
        inspectionDate: this.data.inspectionDate ? this.data.inspectionDate.replace(/-/g, "/") : "", // 検査日
        analysisResultNote: this.data.memo,  // 解析結果入力備考
        patientNote: this.detailData.patientBiko, // 患者情報備考
        analysisNote: !this.data.holterRequestId ? this.detailData.analysisDataInfo.biko : "", // 解析データ備考
        cvhri: !this.isCvhriNotCalcCheck ? this.data.cvhri: -1, // CVHRI チェックボックス「CVHRI算出不可=false」:CVHRI入力項目への設定値、「CVHRI算出不可=true」:-1(算出不可)
        afKind: this.data.af,
      });
      obj.preUpFiles = this.preUpFiles.map(item => item['address']);
      for(let updatedFile of this.currentUploadFile){
        obj.preUpFiles.push(updatedFile.filePath);
      }
      this.currentUploadFile = [];
      return client.apis.internalHolterAnalysis.setHAnalysisTempSavePOST({
        body:obj
      });
    },
    setHolterAnalysisTempSavePOSTSuccess: function(result) {
      this.showSuccess(result)
      this.getReceptionData()
      this.getDetail()
    },
    setHolterAnalysisTempSavePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    approvalRequest: async function() {
      // 承認依頼
      // バリデーションチェック
      var errMsg = ""
      var elements = document.getElementsByClassName("edit");
      var result = this.selfMadeValidation(elements);
      if(result.isError) {
        errMsg = result.msg
      }
      if (this.upFiles.length==0 && this.preUpFiles.length == 0) {
        errMsg = errMsg + "添付データが選択されていません。\n"
      } else {
        let preNameList = this.preUpFiles.map(item => item['path']);
        let nameList = this.upFiles.map(item => item['path']);
        nameList = nameList.concat(preNameList);
        for(let i = 0; i < nameList.length; i++){
          if(nameList[i].startsWith("/")){
            let zipName = nameList[i].replace("/", "");
            nameList[i] = zipName + ".zip"
          }
        }
        const setElements = new Set(nameList);
        if (setElements.size !== nameList.length) {
          errMsg = errMsg + "添付データの重複しているファイルが存在します。\n"
        }
        let targetFile = this.upFiles;
        let okSize = await this.checkUploadFileSize(targetFile);
        if(!okSize){
          errMsg = errMsg + "2GBを超えるファイルはアップロードできません。\n"
        }
      }
      if(errMsg) {
        this.showErrorMessage(errMsg)
        return
      }

      // ファイル名チェック
      var fileNameCheck = true
      for(let uploadItemIfno of this.upFiles){
        var name = uploadItemIfno.file.name
        if(name.indexOf(".") != -1){
          if(name.indexOf(this.uploadFileName) == -1){
            // ファイル名に含まれない
            fileNameCheck = false
            break;
          }
        }
      }
      if(!fileNameCheck){
        this.showErrorMessage("添付したファイルの患者名と医療機関名が正しくない可能性があります。")
        return
      }
      //まずはファイルのアップロードから
      this.multipleUpload(this.upFiles ,this.data.receiptNumber, this.UploadType.holter_report)
      .then(reslut =>{
        this.currentUploadFile = reslut;
        var excuteApi = this.setHolterAnalysisResultApprovalRequestPOST;
        var successCallBack = this.setHolterAnalysisResultApprovalRequestPOSTSuccess;
        var errorCallBack = this.setHolterAnalysisResultApprovalRequestPOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      })
      .catch(error =>{
        this.showErrorMessage("ファイルアップロードに失敗した為、申込みをキャンセルしました。<br>再度実行してください。");
      });
    },
    setHolterAnalysisResultApprovalRequestPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.inspectionDate = obj.inspectionDate ? obj.inspectionDate.replace(/-/g, "/") : ""
      obj.preUpFiles = this.preUpFiles.map(item => item['address']);
      for(let updatedFile of this.currentUploadFile){
        obj.preUpFiles.push(updatedFile.filePath);
      }
      this.currentUploadFile = [];
      // 申送り事項
      obj.applicationNote = this.detailData.biko
      if(!this.data.holterRequestId){
        // 患者情報備考
        obj.patientNote = this.detailData.patientBiko
        // 解析データ情報備考
        obj.analysisNote = this.detailData.analysisDataInfo.biko
      }
      // CVHRI
      if(this.isCvhriNotCalcCheck){
        // チェックボックス「算出不可」がture(チェック有)の場合、CVHRIのパラメーターとして-1(算出不可)を設定
        obj.cvhri = -1;
      }
      // バージョン
      obj.version = this.version
      return client.apis.internalHolterAnalysis.setHAnalysisResultApprovalRequestPOST({
        body:obj
      });
    },
    setHolterAnalysisResultApprovalRequestPOSTSuccess: function(result) {
      this.showMessage("承認依頼を受け付けました。");
      this.back();
    },
    setHolterAnalysisResultApprovalRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    dataReplace: function(reason) {
      // データ差し替え依頼
      let _this = this;
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalHolterAnalysis.setHAnalysisResultDataReplacementRequestPOST({
            body:{
                receiptNumber:_this.data.receiptNumber,
                reason: reason,
                version: _this.version
              }
          });
        },
        function(result) {
          _this.showSuccess(result);
          _this.back();       
        },
        function(result) {
          _this.showErrorMessage(result);
        }
      );
    },
    analysisCancel: function(reason) {
      // 解析をキャンセル
      let _this = this;
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalHolterAnalysis.setHAnalysisResultInspectionCancelPOST({
            body:{
                receiptNumber:_this.data.receiptNumber,
                reason: reason,
                version: _this.version
              }
          });
        },
        function(result) {
          _this.showSuccess(result);
          _this.back();       
        },
        function(result) {
          _this.showErrorMessage(result);
        }
      );
    },
    reInspectAdjust: function(reason) {
      // 再検査調整
      let _this = this;
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalHolterAnalysis.setHAnalysisResultInspectionAdjustmentPOST({
            body:{
                receiptNumber:_this.data.receiptNumber,
                analysisMethod:_this.data.analysisMethod,
                hospitalName:_this.data.hospital,
                reason: reason
              }
          });
        },
        function(result) {
          _this.showSuccess(result);
          _this.back();       
        },
        function(result) {
          _this.showErrorMessage(result);
        }
      );
    },
    dragEnter: function() {
      this.isUpdateModal = true;
    },
    dragLeave: function() {
      this.isUpdateModal = false;
    },
    fileDorop: async function(event) {
      for(let i =0 ; i < event.dataTransfer.items.length; i++){
        const item = event.dataTransfer.items[i];
        const entry = item.webkitGetAsEntry();
        let path = entry.name;
        if(entry.isDirectory){
          path = entry.fullPath;
        }
        this.upFiles.push({ file: entry, path: path});
      }
      this.isUpdateModal = false;
    },
    addUploadfile: function(){
      for(let upFile of this.upButtonFile){
        this.upFiles.push({ file: upFile, path: upFile.name});
      }
      this.upButtonFile = [];
    },
    deleteUpfile: function(upFileList, index){
      upFileList.splice(index, 1);
    },
    isHolterService: function(){
      if (this.kind == "ホルター心電図配送ｻｰﾋﾞｽ") {
        return true;
      }
      return false;
    },
    clipboardCopy: function(){
      navigator.clipboard.writeText(this.uploadFileName).then(() => {
        this.showMessage('クリップボードにコピーしました。');
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
      });
    },
  },
  data() {
    let analysisMethodList = this.getChoiceList(choicesType.holterMethod, true);
    var item = this.$route.params["item"];
    var analyistSelectModalActive;
    var receiptNumber = item.receiptNumber;
    var kind = item.kind;
    var version = item.version;
    var reportList = [];
    for (var report of item.reportFileList) {
      reportList.push({ file: report, fileId: report.fileId, path: report.fileName, address: report.fileAddress})
    }
    var searchParams = this.$route.params["searchConditions"];
    var detailData = {analysisDataInfo:{attachedDataFileList:{}}};
    return {
      role: role,
      analyistSelectModalActive: analyistSelectModalActive,
      analystId: null,
      data: [],
      UploadType:UploadType,
      receiptNumber: receiptNumber,
      detailData,
      searchParams,
      upFiles: [],
      preUpFiles:reportList,
      upButtonFile:null,
      isUpdateModal: false,
      kind: kind,
      replaceReasonInputModalActive:false,
      cancelReasonInputModalActive:false,
      reInspectReasonInputModalActive:false,
      currentUploadFile:[],
      showDetail:false,
      version: version,
      replaceFiles: [],
      uploadFileName:"",
      analysisMethodList: analysisMethodList,
      atLaunchHidden: atLaunchHidden,
      isCvhriNotCalcCheck: false
    };
  },
  filters: {
    choiceFilter: function(val, list){
      if(!val) return val
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    holterAnalysisRequestDetail: holterAnalysisRequestDetail,
    analyistSelectModal:AnalyistSelectModal,
    reasonInputModal:reasonInputModal,
  },
  mounted: function() {
    // 詳細情報取得
    this.getReceptionData()
    this.getDetail()
  }
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
.reject-reason-table {
  border-collapse: collapse;
  table-layout: fixed;
}
.reject-reason-table th {
  padding: 1px 0;
  border: 1px solid;
  text-align: center;
  vertical-align: middle;
}
.reject-reason-table td {
  padding: 1px 0 1px 10px;
  border: 1px solid;
  vertical-align: middle;
}
.reject-reason-table th.reject-date,
.reject-reason-table td.reject-date {
  width: 20% !important;
}
.delay {
  font-weight: bold;
}
.delay,
.error {
  color: red;
  margin-left: 5px;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
.clipbordcopy {
  margin-left:3%;
  right: 10px;
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/holterAnalysis/HolterAnalysisResultDetail.vue